import { useState } from 'react'
import { InputGroup, InputRightElement, Spinner, Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { cepMask } from 'utils/masks'
import { validateCEP } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useGetAddressByCEP from 'components/tools/CustomForm/hooks/useGetAddressByCEP'
import CustomFormAddressByCEP from 'components/tools/CustomForm/commonComponents/CustomFormAddressByCEP'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValueCEP({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const { address, handleGetAddressByCEP, loadingAddress } = useGetAddressByCEP()

  const handleValidateCEP = async (cep: string): Promise<boolean> => {
    let initialValue = { isValid: true, message: '' }

    if (cep && !validateCEP(cep)) {
      initialValue = { isValid: false, message: 'CEP está incorreto' }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })
  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack spacing={0}>
      <FormItem label="Valor inicial">
        <InputGroup>
          <MaskedInput
            mask={cepMask}
            {...formMethods.register('default_value', {
              validate: handleValidateCEP,
              onBlur: async (event) => {
                const cep = event.target.value
                await handleGetAddressByCEP(cep)
              },
            })}
          />

          <InputRightElement>{loadingAddress && <Spinner />}</InputRightElement>
        </InputGroup>
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />

      <CustomFormAddressByCEP address={address} />
    </Stack>
  )
}
